<template>
    <div>
        <!-- Modal Balanço Hídrico -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="atendimento">
                    <div class="modal-header">
                        <h5 class="modal-title">Resultados</h5>
                        <button type="button" class="close" @click="fechar_modal()" ria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <entrega-resultado ref="entrega_resultado" :modal="true" :atendimento="atendimento" :viewonly="viewonly" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import EntregaResultado from '../recepcao/EntregaResultado.vue';

export default {
    data() {
        return { 
            chave: "", 
            atendimento: null,
        }
    },

    components: { 
        EntregaResultado
    },

    props: ['viewonly'],

    computed: { 
        modal_name() { 
            return 'entregaResultadoModal' + this.chave;
        }
    },

    methods: { 
        fechar_modal () { 
            $('#' + this.modal_name).modal('hide');    
        },

        abrir (atendimento, inicio = null, fim = null) { 
            this.atendimento = _.cloneDeep(atendimento);

            this.$nextTick(() => { 
                
                this.$refs.entrega_resultado.set_paciente(this.atendimento.paciente);

                if ( inicio || fim ) { 
                    this.$refs.entrega_resultado.set_periodo(inicio, fim);
                }

                this.$refs.entrega_resultado.load(); 

                $('#' + this.modal_name).modal('show');

            });
        }
    },

    mounted() { 
        this.chave = this.$util.uuidv4();
    }
}
</script>
